module.exports = __webpack_public_path__ + "static/media/Hero2.d204c827.png";